<template>
	<section>
		<h1>✨Générer des questions avec I.A</h1>

		<form @submit.prevent="generateQuestion()">
			<div class="all-input-container">
				<div class="input-container">
					<label for="subject">Matière *</label>
					<select name="subject" id="subject" v-model="subject">
						<option
							v-for="subject in getUserSubjects()"
							:key="subject.id"
							:value="subject.id"
							>{{ subject.name }}</option
						>
					</select>
				</div>
				<div class="input-container">
					<label for="level">Niveau</label>
					<select name="level" id="level" v-model="level" >
						<option
							v-for="level in getUserLevels()"
							:key="level.id"
							:value="level.id"
							>{{ level.name }}</option
						>
					</select>
				</div>
				<div v-if="showChapter" class="input-container">
					<label for="chapter">Chapitre</label>
					<select
						class="filter-chapter"
						@change="updateFilter"
						v-model="chapter"
						name="chapter"
						id="chapter"
					>
						<option value="">-----</option>

						<optgroup
							v-for="sequence in getSequence()"
							:key="sequence.id"
							:label="sequence.name"
						>
							<option
								v-for="chapter in this.$store.getters.chapters(
									sequence.id
								)"
								:key="chapter.id"
								:value="chapter.id"
							>
								{{ chapter.name }}
							</option>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="input-container">
				<label for="">Information complémentaire</label>
				<textarea rows="6" v-model="info" name="" id=""></textarea>
			</div>
			<div class="input-container">
				<label for="">Joindre un fichier (format PDF)</label>
				<div v-if="file" class="file-custom-preview">
					<span>{{ file.name }}</span>
					<button type="button" @click="removeFile">✖</button>
				</div>
				<div v-else class="file-custom-preview">
					<input
						type="file"
						@change="setFile"
						ref="fileInput"
						name="file"
						id="file"
						accept=".pdf,.txt,.jpg,.jpeg,.png"
					/>
				</div>
			</div>
			<div class="input-container" v-if="isSuperAdmin">
				<label for="startChunk">Première question</label>
				<input
					type="number"
					id="startChunk"
					v-model.number="startChunk"
					min="1"
				/>
			</div>
			<div class="input-container" v-if="isSuperAdmin">
				<label for="endChunk">Dernière question</label>
				<input
					type="number"
					id="endChunk"
					v-model.number="endChunk"
					:min="startChunk"
				/>
			</div>
			<button class="submit dark">Générer</button>
			<label style="padding-top: 1rem;">
				La génération de questions par IA est succeptible d'échouer.
				Dans un tel cas, nous vous invitons à réessayer.
			</label>
		</form>

		<div class="questions-container qcm">
			<Loader v-if="isLoading" />
			<AIGeneratedQCMQuestion
				v-for="(question, index) in questions"
				:key="index"
				:question="question"
				:chapter="chapter"
				:level="level"
				:subject="subject"
			/>
		</div>
	</section>
</template>
<script>
// import { authenticatedFetch, checkRightFor } from "../../../../utils";
import { checkRightFor } from "../../../../utils/utils";
import Loader from "../../../Loader.vue";
import AIGeneratedQCMQuestion from "./AIGeneratedQCMQuestion.vue";
import { generateAiQcm } from "../../../../services/aiQcmService.js";
export default {
	components: {
		Loader,
		AIGeneratedQCMQuestion
	},
	props: {
		isSuperAdmin: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			subject: "",
			level: "",
			chapter: "",
			showChapter: true,
			questions: [],
			isQuestionAdded: false,
			isLoading: false,
			info: "",
			file: null,
			startChunk: 0,
			endChunk: 0
		};
	},

	methods: {
		setFile(event) {
			const file = event.target.files[0];
			const maxSize = 5 * 1024 * 1024; // 5 Mo
			if (file && file.size > maxSize) {
				this.$store.state.toast = {
					text: "Le fichier ne doit pas dépasser 5 Mo.",
					status: "error"
				};
				event.target.value = "";
				this.file = null;
				return;
			}
			this.file = file;
		},
		removeFile() {
			this.file = null;
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = "";
			}
		},
		checkErrors() {
			if (!this.subject) {
				this.$store.state.toast = {
					text: "Veuillez remplir le champs matière",
					status: "error"
				};
				return true;
			}
			return false;
		},
		getUserSubjects() {
			const subjects = this.$store.getters.subjects(
				this.$store.state.user.subjects
			);
			return subjects;
		},
		getUserLevels() {
			const levels = this.$store.getters.levels(
				this.$store.state.user.levels
			);
			return levels;
		},
		async questionAdded() {
			if (this.isQuestionAdded) return;
			this.$store.state.toast = {
				text: 'A retrouver dans "Mes questions"',
				status: "success"
			};
			this.isQuestionAdded = true;
		},
		getSequence() {
			if (this.$store.state.user.subjects.length == 1) {
				this.subject = this.$store.state.user.subjects[0];
			}
			return this.$store.getters.sequencesByLevelAndSubject(
				this.level,
				this.subject
			);
		},
		async generateQuestion() {
			if (!checkRightFor("QCM", [])) {
				this.$store.state.isPopUpNotAllowedVisible = true;
				return;
			}
			if (this.checkErrors()) return;
			this.isLoading = true;
			await this.$nextTick();

			try {
				this.questions = [];
				const formData = new FormData();

				if(this.subject) {
					formData.append(
						"subject_name",
						this.$store.state.subjects.find(s => s.id == this.subject)
							.name
					);
				}

				if(this.chapter) {
					formData.append(
						"chapter_name",
						this.$store.state.chapters.find(c => c.id == this.chapter)
							.name
					);
				}

				if(this.level) {
					formData.append(
						"level_name",
						this.$store.state.levels.find(l => l.id == this.level).name
					);
				}

				formData.append("info", this.info);
				if (this.file) {
					formData.append("file", this.file);
				}

				if (this.isSuperAdmin) {
					const promises = [];
					const step = 5;
					let start = this.startChunk;
					let end = this.endChunk;

					for (
						let chunkStart = start;
						chunkStart <= end;
						chunkStart += step
					) {
						const chunkEnd = Math.min(chunkStart + step - 1, end);
						const formDataCopy = new FormData();
						for (let pair of formData.entries()) {
							formDataCopy.append(pair[0], pair[1]);
						}
						formDataCopy.set("startChunk", chunkStart);
						formDataCopy.set("endChunk", chunkEnd);

						promises.push(generateAiQcm(formDataCopy, true));
					}

					const results = await Promise.allSettled(promises);

					const indexedQuestions = results.map((r, i) => ({
						index: i,
						value: r.status === "fulfilled" ? r.value : []
					}));

					indexedQuestions.sort((a, b) => a.index - b.index);
					this.questions = indexedQuestions
						.map(obj => obj.value)
						.flat();
				} else {
					this.questions = await generateAiQcm(formData, false);
				}

				for (const question of this.questions) {
					question.customId = Math.random()
						.toString(36)
						.substring(7);
				}

				if (this.questions.length === 0) {
					this.$store.state.toast = {
						text:
							"Aucune question n'a pu être générée, veuillez réessayer.",
						status: "error"
					};
				}
				this.isLoading = false;
			} catch (error) {
				console.error(error);
				this.$store.state.toast = {
					text:
						"Une erreur est survenue pendant la génération, veuillez réessayer",
					status: "error"
				};
			} finally {
				this.isLoading = false;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/scss/admin/ai-generated-content.scss";
</style>
